import React from 'react';
import { Bomb, CheckCircle2, XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="comprar" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-102">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-luminosity" data-id="element-103"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-104">
        <div className="text-center mb-12" data-id="element-105">
          <div className="inline-flex items-center justify-center gap-3 bg-red-600/20 text-red-400 border border-red-500/30 px-6 py-2 rounded-full font-bold text-lg mb-8" data-id="element-106">
            <Bomb className="w-5 h-5" data-id="element-107" />
            ESTO NO ES UN EBOOK
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-black text-white" data-id="element-108">
            Es un sistema completo.
          </h2>
        </div>

        <div className="bg-navy-950 rounded-3xl border-2 border-gold-500/50 shadow-[0_0_50px_rgba(212,168,67,0.15)] overflow-hidden" data-id="element-109">
          <div className="p-8 md:p-12 border-b border-navy-800" data-id="element-110">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-111">
              <span data-id="element-112">📦</span> TODO LO QUE INCLUYE TU COMPRA
            </h3>

            <div className="bg-navy-900 rounded-xl p-6 border border-navy-700 mb-8" data-id="element-113">
              <p className="text-red-400 font-bold mb-4 flex items-center gap-2" data-id="element-114">
                <span className="w-3 h-3 bg-red-500 rounded-full animate-pulse" data-id="element-115"></span>
                Acceso inmediato a:
              </p>
              <ul className="space-y-4 text-lg text-white font-medium" data-id="element-116">
                <li className="flex items-center gap-3" data-id="element-117">
                  <span data-id="element-118">📘</span> Charter Command System™ (Capitán)
                </li>
                <li className="flex items-center gap-3" data-id="element-119">
                  <span data-id="element-120">⚙️</span> Sistema del Ingeniero{' '}
                  <span className="text-xs bg-red-600 text-white px-2 py-1 rounded-full ml-auto" data-id="element-121">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-122">
                  <span data-id="element-123">🍽️</span> Sistema del Chef{' '}
                  <span className="text-xs bg-red-600 text-white px-2 py-1 rounded-full ml-auto" data-id="element-124">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-125">
                  <span data-id="element-126">🧼</span> Sistema de Azafata{' '}
                  <span className="text-xs bg-red-600 text-white px-2 py-1 rounded-full ml-auto" data-id="element-127">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-128">
                  <span data-id="element-129">⚓</span> Sistema del Marinero{' '}
                  <span className="text-xs bg-red-600 text-white px-2 py-1 rounded-full ml-auto" data-id="element-130">
                    GRATIS HOY
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-131">
                  <span data-id="element-132">🚀</span> Manual del Capitán Nuevo{' '}
                  <span className="text-xs bg-red-600 text-white px-2 py-1 rounded-full ml-auto" data-id="element-133">
                    GRATIS HOY
                  </span>
                </li>
              </ul>
            </div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-134">
              <div data-id="element-135">
                <h4 className="flex items-center gap-2 text-white font-bold mb-4" data-id="element-136">
                  <span data-id="element-137">🔥</span> Lo que vas a eliminar definitivamente
                </h4>
                <ul className="space-y-2 text-slate-400" data-id="element-138">
                  <li className="flex items-center gap-2" data-id="element-139">
                    <XCircle className="w-4 h-4 text-red-500" data-id="element-140" /> Confusión
                  </li>
                  <li className="flex items-center gap-2" data-id="element-141">
                    <XCircle className="w-4 h-4 text-red-500" data-id="element-142" /> Repeticiones
                    constantes
                  </li>
                  <li className="flex items-center gap-2" data-id="element-143">
                    <XCircle className="w-4 h-4 text-red-500" data-id="element-144" /> Tareas mal
                    hechas
                  </li>
                  <li className="flex items-center gap-2" data-id="element-145">
                    <XCircle className="w-4 h-4 text-red-500" data-id="element-146" /> Falta de
                    coordinación
                  </li>
                  <li className="flex items-center gap-2" data-id="element-147">
                    <XCircle className="w-4 h-4 text-red-500" data-id="element-148" /> Estrés
                    innecesario
                  </li>
                </ul>
              </div>

              <div data-id="element-149">
                <h4 className="flex items-center gap-2 text-white font-bold mb-4" data-id="element-150">
                  <span data-id="element-151">✅</span> Lo que vas a ganar
                </h4>
                <ul className="space-y-2 text-slate-300" data-id="element-152">
                  <li className="flex items-center gap-2" data-id="element-153">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-154" /> Orden
                    total
                  </li>
                  <li className="flex items-center gap-2" data-id="element-155">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-156" /> Control
                    real
                  </li>
                  <li className="flex items-center gap-2" data-id="element-157">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-158" /> Claridad
                    en todo el equipo
                  </li>
                  <li className="flex items-center gap-2" data-id="element-159">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-160" />{' '}
                    Operación fluida
                  </li>
                  <li className="flex items-center gap-2" data-id="element-161">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-162" />{' '}
                    Liderazgo sólido
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12 bg-gradient-to-b from-navy-950 to-navy-900 text-center" data-id="element-163">
            <div className="mb-8" data-id="element-164">
              <p className="text-slate-400 text-lg line-through mb-2" data-id="element-165">
                Precio regular: $99.000
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-166">
                <span className="text-5xl md:text-7xl font-heading font-black text-white" data-id="element-167">
                  $42.000
                </span>
                <span className="text-sm text-left text-slate-400 leading-tight" data-id="element-168">
                  Pago
                  <br data-id="element-169" />
                  Único
                </span>
              </div>
            </div>

            <CTAButton isMain={true} className="w-full md:w-auto md:px-16 md:py-6 text-xl md:text-2xl" data-id="element-170" />

            <p className="text-slate-500 text-sm mt-6 flex items-center justify-center gap-2" data-id="element-171">
              🔒 Pago 100% seguro y encriptado
            </p>
          </div>
        </div>
      </div>
    </section>;
}